import { render, staticRenderFns } from "./Legal.vue?vue&type=template&id=8b6b8a96&scoped=true&"
import script from "./Legal.vue?vue&type=script&lang=ts&"
export * from "./Legal.vue?vue&type=script&lang=ts&"
import style0 from "./Legal.vue?vue&type=style&index=0&id=8b6b8a96&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6b8a96",
  null
  
)

export default component.exports